const classes = Object.freeze({
    root: 'll-button ll-accent-button',
    disabled: 'll-button ll-accent-button ll-accent-button_disabled',
    label: 'll-accent-button__label'
});

export {
    classes,
};